import React, { useEffect, useState } from "react";
import { Typography } from "@material-ui/core";
import getId from "../../../utils/getId";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import { Seat } from "../../../models/Seat";
import { TicketBillLine } from "../../../models/TicketBillLine";
import { ZoneSeats } from "../../../models/ZoneSeats";
import { RowZone } from "../../../models/RowZone";
import SeatView from "./SeatView";
import "./scheme.css";
import useDraggingMouseAndTouch from "../../../utils/hook/useDraggingMouseAndTouch";
import useDesktopSize from "../../../utils/hook/useDesktopSize";
import RoomSchemeScale from "../../../shared/RoomSchemeScale";
import hasValue from "../../../utils/hasValue";

interface IProps {
  zoneScheme: ZoneSeats;
  onSelectedSeat: (rowZone: RowZone, seat: Seat) => void;
  section: Seat;
}

export const retStatusSeat = (status: string) => {
  switch (status) {
    case "A":
      return "free";
    case "I":
      return "busy";
    case "W":
      return "selected";
    case "U":
      return "noAvailable";
    case "B":
      return "noAvailable";
    case "R":
      return "busy";
    default:
      return "free";
  }
};

export const seatIsNoAvailable = (status: string) => {
  switch (status) {
    case "I":
      return true;
    case "U":
      return true;
    case "B":
      return true;
    default:
      return false;
  }
};

export const seatIsInBasket = (seat: Seat, basket: TicketBillLine[]) => {
  return basket.some(item => item.ticketAccessList.some(ticketAccess => getId(ticketAccess.seat) === getId(seat)));
};

const RoomSchame: React.FC<IProps> = ({ zoneScheme, onSelectedSeat, section }: IProps) => {
  const isDesktop = useDesktopSize();
  const basket = useSelector((state: State) => state.basket.basket);
  const calculateDistanceToNext = zoneScheme.rowZones?.map(scheme => {
    let distance = 0;
    return {
      ...scheme,
      seats: scheme.seats.map(seat => {
        distance +=
          // seat.width +
          seat.distanceToNext;
        // console.log('Obliczam distanceToNext dla: '+seat.name+', distanceToNext: '+seat.distanceToNext+', obliczylem distance: '+distance);
        return {
          ...seat,
          distanceToNext: seat.distanceToNext,
          status: seatIsInBasket(seat, basket) ? "W" : seat.status
        };
      })
    };
  });

  const {
    containerRef,
    contentRef,
    roomSchameScale,
    setRoomSchameScale,
    handleMouseDown,
    handleMouseLeave,
    handleMouseMove,
    handleMouseUp,
    handleWheel,
    handleMouseEnter
  } = useDraggingMouseAndTouch();

  const isAddMarginLeftToSeat = () => {
    if (hasValue(section)) {
      if (section.shape === "quadrantArcTopRight" || section.shape === "quadrantArcBottomRight") {
        return true;
      }
    }

    return false;
  };

  const isAddMarginTopToSeat = () => {
    if (hasValue(section)) {
      if (section.shape === "quadrantArcBottomRight") {
        return true;
      }
    }

    return false;
  };

  useEffect(() => {
    setRoomSchameScale(isDesktop ? 1 : 0.35);

    if (!isDesktop) {
      const scrollContainer = containerRef.current;
      if (scrollContainer) {
        scrollContainer.scrollLeft = scrollContainer.scrollWidth;
      }
    }
  }, [isDesktop]);

  return (
    <React.Fragment>
      <RoomSchemeScale roomSchameScale={roomSchameScale} setRoomSchameScale={setRoomSchameScale} />
      <div
        id="container"
        style={{
          position: "relative",
          width: "100vw",
          height: "100vh",
          overflow: isDesktop ? "hidden" : "scroll",
          marginTop: "5px",
          marginBottom: "50px",
          marginLeft: isDesktop ? "7px" : 0,
          cursor: "grab",
          userSelect: "none",
          WebkitUserSelect: "none",
          MozUserSelect: "none",
          msUserSelect: "none"
        }}
        ref={containerRef}
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseLeave}
        onMouseMove={handleMouseMove}
        onWheel={handleWheel}
        onMouseEnter={handleMouseEnter}
      >
        {calculateDistanceToNext === undefined || calculateDistanceToNext.length === 0 ? (
          <Typography>Brak danych</Typography>
        ) : (
          <div style={{ transform: `scale(${roomSchameScale})` }}>
            {calculateDistanceToNext.map((item, index) => (
              <React.Fragment key={index}>
                {item.seats[0].status !== "X" && (
                  <div
                    style={{
                      // backgroundColor: "#0394fc",
                      height: `${item.seats[0].height}px`,
                      // width: `${item.seats[0].width + 50}px`,
                      width: `100px`,
                      // border: "1px solid black",
                      position: "absolute",
                      top: `${item.rowZone.coordinateY}px`,
                      textAlign: "center",
                      color: "black",
                      left: `${item.rowZone.coordinateX}px`,
                      cursor: "pointer",
                      lineHeight: `${item.seats[0].height}px`,
                      transform: `rotate(${item.rowZone.orientation}deg)`
                    }}
                  >
                    <span>{item.rowZone.name}</span>
                  </div>
                )}
                {item.seats.map((seat, indexS) => (
                  <div
                    ref={contentRef}
                    key={`${index}${indexS}`}
                    onClick={
                      seatIsNoAvailable(seat.status ?? "")
                        ? () => {}
                        : () => {
                            onSelectedSeat(item.rowZone, seat);
                          }
                    }
                  >
                    <SeatView
                      title={seat.name}
                      top={isAddMarginTopToSeat() ? seat.y + 30 : seat.y}
                      left={isAddMarginLeftToSeat() ? seat.x + 65 : seat.x}
                      height={seat.height}
                      width={seat.width}
                      shape={seat.shape}
                      pictureUrl={seat.picture_url}
                      rotation={seat.rotation}
                      colorClass={retStatusSeat(seat.status ?? "noAvailable")}
                      status={seat.status ?? ""}
                      textTooltip={seat.description}
                    />
                  </div>
                ))}
              </React.Fragment>
            ))}
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default RoomSchame;
